module.exports = __webpack_public_path__ + "media/images/img_service_service_2-f0eaef292fe617da32f67c2083d92396.png";